import {createStore, applyMiddleware} from 'redux'
import {routerMiddleware} from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'
import throttle from 'lodash/throttle'
import logger from './middleware/logger'
import reducers from './reducers'
import * as localStorage from './helpers/localStorage'

export const history = createHistory()

const configureStore = () => {
  var store
  const routingMiddleware = routerMiddleware(history)
  const persistedState = localStorage.loadState()

  if (process.env.NODE_ENV === 'development') {
    const createStoreWithMiddleware = applyMiddleware(
      routingMiddleware,
      logger,
    )(createStore)

    store = createStoreWithMiddleware(
      reducers,
      persistedState,
      window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__(),
    )
  } else {
    const createStoreWithMiddleware = applyMiddleware(routingMiddleware)(
      createStore,
    )

    store = createStoreWithMiddleware(reducers, persistedState)
  }

  store.subscribe(
    throttle(() => {
      const state = store.getState()

      localStorage.saveState(state)
    }, 1000),
  )

  return store
}

export const store = configureStore()



// WEBPACK FOOTER //
// ./src/store.js